/**
 * Main website header
 * Verify if the user is scrolling / not at the top of the page
 * If we're scrolling, apply stick class
 * Initialize the mega menu Lenis instance for smooth scrolling
 *
 * @returns {{init(): void, onScroll(): void, megaMenuOpen: boolean, isScrolled: boolean, closeMenu(*): void, toggleMenu(*): void}}
 */
export default () => ({
    isScrolled: false,
    megaMenuOpen: false,

    init() {
        this.onScroll();
    },

    onScroll() {
        this.isScrolled = window.scrollY > 10 || window.config.NAVIGATION_SCROLLED_BY_DEFAULT;
    },

    toggleMenu(event) {
        event.stopPropagation();

        if (this.megaMenuOpen) {
            this.closeMenu(event);
        } else {
            this.megaMenuOpen = true;
        }
    },

    closeMenu(event) {
        event.stopPropagation();

        if (this.megaMenuOpen) {
            this.megaMenuOpen = false;

            let menuNav = document.querySelector('#mega-menu-navigation');
            if (menuNav) {
                menuNav.classList.add('mega-menu-nav-outro');
            }

            setTimeout(() => menuNav.classList.remove('mega-menu-nav-outro'), 2000);
        }
    }
});
